/*
 * Corner Boxe · fiche produit
 * - dates de livraison calculées chaque jour dans le navigateur (la page peut être servie depuis le cache Shopify)
 * - compteur « 1 / 9 » de la galerie
 * - barre collante affichée quand le bouton principal n'est plus visible
 * - boutons « Ajouter au panier » secondaires : soumettent le formulaire produit du thème et suivent son prix
 * - textes qui suivent la variante choisie : [prix] et [variante] (comparatif), valeurs par taille (caractéristiques)
 */
(() => {
  if (window.cbProductLoaded) return;
  window.cbProductLoaded = true;

  const getMainForm = () => document.querySelector('[data-cb-main] form[is="product-form"]');

  /* ---------- Dates de livraison ---------- */

  const formatDate = (days) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return new Intl.DateTimeFormat(document.documentElement.lang || 'fr', { day: 'numeric', month: 'short' }).format(date);
  };

  const renderDeliveryDates = () => {
    document.querySelectorAll('[data-cb-delivery-date]').forEach((element) => {
      const min = parseInt(element.dataset.min, 10);
      const max = parseInt(element.dataset.max, 10);
      element.textContent = element.dataset.template.replace('{min}', formatDate(min)).replace('{max}', formatDate(max));
    });
  };

  /* ---------- Compteur de la galerie ---------- */

  const setupGalleryCounter = (counter) => {
    const carousel = counter.closest('.cb-main__media')?.querySelector('media-carousel');
    if (!carousel || counter.dataset.ready) return;
    counter.dataset.ready = 'true';

    // L'index du carrousel compte aussi les médias masqués (images d'autres variantes) : la position affichée est
    // celle du média courant parmi les médias visibles.
    const update = (index) => {
      const all = Array.from(carousel.children).filter((item) => item.matches('.product-gallery__media'));
      const items = all.filter((item) => !item.hidden);
      const rawIndex = typeof index === 'number' ? index : parseInt(carousel.getAttribute('initial-index'), 10) || 0;
      const position = Math.max(items.indexOf(all[rawIndex]), 0) + 1;
      counter.textContent = `${position} / ${items.length}`;
      counter.hidden = items.length < 2;
    };

    carousel.addEventListener('carousel:change', (event) => update(event.detail?.index));
    update();
  };

  /* ---------- Barre collante ---------- */

  const setupStickyBar = (main) => {
    const sticky = main.querySelector('[data-cb-sticky]');
    const anchor = main.querySelector('[data-cb-atc-anchor]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(anchor);
  };

  /* ---------- Boutons secondaires ---------- */

  // Le bouton principal vient d'être re-rendu par le thème (product:rerender précède variant:change) :
  // les boutons secondaires recopient son libellé, son prix et son état.
  const syncSecondaryButtons = () => {
    const source = document.querySelector('[data-cb-main] [data-cb-atc-anchor] button[type="submit"]');
    if (!source) return;

    document.querySelectorAll('[data-cb-atc]').forEach((button) => {
      button.innerHTML = source.innerHTML;
      button.disabled = source.disabled;
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cb-atc]');
    if (!button) return;

    const form = getMainForm();
    if (!form) return;

    event.preventDefault();
    button.setAttribute('aria-busy', 'true');
    form.addEventListener('variant:add', () => button.removeAttribute('aria-busy'), { once: true });
    form.addEventListener('cart:error', () => button.removeAttribute('aria-busy'), { once: true });
    form.requestSubmit();
  });

  // Textes avec [prix] / [variante] (comparatif…) : le prix est recopié du bouton principal, déjà formaté par le thème
  const syncVariantTokens = (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    document.querySelectorAll('[data-cb-variant-title]').forEach((element) => { element.textContent = variant.title; });

    // Valeurs par variante (caractéristiques) : seule celle de la variante choisie reste visible
    document.querySelectorAll('[data-cb-variant-value]').forEach((element) => {
      element.hidden = element.dataset.cbVariantValue !== String(variant.id);
    });

    const price = document.querySelector('[data-cb-main] [data-cb-atc-anchor] [data-cb-atc-price]');
    if (price) {
      document.querySelectorAll('[data-cb-variant-price]').forEach((element) => { element.textContent = price.textContent; });
    }
  };

  document.addEventListener('variant:change', syncSecondaryButtons);
  document.addEventListener('variant:change', syncVariantTokens);

  /* ---------- Initialisation (et rechargement des sections dans l'éditeur) ---------- */

  const init = () => {
    renderDeliveryDates();
    document.querySelectorAll('[data-cb-gallery-counter]').forEach(setupGalleryCounter);
    document.querySelectorAll('[data-cb-main]').forEach((main) => {
      if (main.dataset.cbReady) return;
      main.dataset.cbReady = 'true';
      setupStickyBar(main);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
